<template>
  <Nav></Nav>
  <main class="account">
    <back-button></back-button>
    <AccountEditor :edit="true" :slug="slug"></AccountEditor>
    <Permission :slug="slug"></Permission>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import AccountEditor from '@/components/AccountEditor.vue';
import Permission from '@/components/Permission.vue';

export default defineComponent({
  name: 'Account',
  components: {
    BackButton,
    Nav,
    AccountEditor,
    Permission,
  },
  data() {
    return {
      slug: this.$route.params.slug as string,
    };
  },
});
</script>